import React from "react";
import { Link } from "react-router-dom";
import { ListItem } from "@deere/ux.uxframe-react";
import { Box, Grid, Typography } from '@deere/fuel-react';

export const Supplier = ({ supplierData, isAdmin }) => {
    let path = isAdmin ? `/supplier-mnt/edit-ae-supplier/${supplierData.supplierNumber}` : `/supplier-mnt/view-ae-supplier/${supplierData.supplierNumber}`
    return (
        <ListItem className="list-group-item mb-1" style={{ borderRadius: "0.25rem" }} key={supplierData.id}>
            <Grid container>
                <Grid item xs={12} md={10}>
                    <Link
                        to={{
                            pathname: path,
                        }}>
                        {supplierData.supplierNumber} - {supplierData.supplierName}
                    </Link>
                </Grid>
                <Grid item xs={12} md={2}>
                    <Box display="flex" justifyContent="flex-start" ml={4}>
                        <Typography size="md" fontWeight="bold" component="p" display="inline">
                            AE Supplier &nbsp;&nbsp;
                        </Typography>
                        <Typography size="md" fontWeight="regular" component="p" display="inline">
                            {supplierData.supplierInd === "Y" ? "Yes" : "No"}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Typography size="md" fontWeight="bold" component="p" display="inline">
                        Functional Area & SubFunctional Area {" "}
                    </Typography>
                    <Typography size="md" fontWeight="regular" component="p" display="inline">
                        {supplierData.functionalArea.description}
                        <span> -   {supplierData.subFunctionalArea.description} </span>
                    </Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
}